import { render } from "./Remove.vue?vue&type=template&id=2de237ce&scoped=true"
import script from "./Remove.vue?vue&type=script&lang=ts"
export * from "./Remove.vue?vue&type=script&lang=ts"

import "./Remove.vue?vue&type=style&index=0&id=2de237ce&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-2de237ce"

export default script